import React, { useState, useEffect } from 'react';
import ProductTypeResult from '../Search/ResultTypes/ProductTypeResult';
import { filterGEOProductSKUs } from '../../tools/utilities';
import { ga4TrackingEcommerce } from '../../modules/tracking';

const RelatedProducts = ({
    results,
    title = 'Related Products',
    country,
    currency,
    userGeoData
}) => {
    const [sendViewItem, setSendViewItem] = useState(true);
    
    useEffect(() => {
        if (sendViewItem && results.length > 0 && results !== null) {
            const items = results
                .map(result => {
                    let selectedSku = null;
                    const skus = filterGEOProductSKUs(result._source.skus, currency, country);
                    if (skus.length > 0) {
                        const firstKey = Object.keys(skus)[0];
                        selectedSku = skus[firstKey];
                    }
    
                    return selectedSku;
                })
                .filter(result => result !== null);
            if (items.length > 0) {
                ga4TrackingEcommerce('view_item', items);
                setSendViewItem(false);
            }
        }
    }, [sendViewItem, results]);

    const relatedProducts = results.map(item => {
        return <ProductTypeResult
            key={item._source.id}
            item={item._source}
            analytics="ga-product-related"
            country={country}
            currency={currency}
            userGeoData={userGeoData}
        />;
    });

    return (
        <div className="container">
            <header className="content-header">
                <div className="content-header__intro user-content">
                    <h2 className="content-header__title sanomat">{title}</h2>
                </div>
                <div className="content-header__button">
                    <a className="button button--outline button--full" href="/shop/">
                        Visit shop
                    </a>
                </div>
            </header>
            <div className="content-section__inner-content container">
                <div className="latest-products__grid">{relatedProducts}</div>
            </div>
        </div>
    );
};

export default RelatedProducts;
